var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: !_vm.isShowContent,
          expression: "!isShowContent",
        },
      ],
      attrs: { block: !_vm.isShowContent },
    },
    [
      _vm.systemMessage
        ? _c(
            "div",
            [
              _c("el-alert", {
                attrs: {
                  closable: false,
                  title: _vm.systemMessage,
                  type: "warning",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.isShowContent
        ? _c(
            "div",
            { staticClass: "flex-container" },
            _vm._l(_vm.productList, function (itemData, index) {
              return _c(
                "div",
                { key: index },
                [
                  _c(
                    "el-card",
                    {
                      staticStyle: {
                        width: "260px",
                        height: "380px",
                        "margin-bottom": "20px",
                      },
                      attrs: {
                        "body-style": { padding: "15px 15px 0 15px" },
                        shadow: "hover",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        { attrs: { justify: "center", type: "flex" } },
                        [
                          _c("img", {
                            staticClass: "image",
                            attrs: {
                              alt: "",
                              height: "100px",
                              src: itemData.groupLogo,
                              width: "100px",
                            },
                          }),
                        ]
                      ),
                      _c(
                        "el-row",
                        {
                          staticStyle: { height: "32px" },
                          attrs: { justify: "center", type: "flex" },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "1em",
                                "font-weight": "bold",
                              },
                            },
                            [_vm._v(_vm._s(itemData.title))]
                          ),
                        ]
                      ),
                      _c(
                        "el-row",
                        { attrs: { justify: "end", type: "flex" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleView(itemData)
                                },
                              },
                            },
                            [_vm._v("查看详细>>")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { justify: "start", type: "flex" } },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "1em",
                                "font-weight": "bold",
                              },
                            },
                            [
                              _vm._v(
                                "￥" + _vm._s(itemData.price / 100) + " 起"
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "el-row",
                        {
                          staticStyle: { "margin-top": "5px", height: "20px" },
                          attrs: { justify: "start", type: "flex" },
                        },
                        [
                          _vm.isHasCategory(itemData.insureType)
                            ? _c(
                                "el-link",
                                {
                                  staticStyle: {
                                    "font-size": "0.8em",
                                    "margin-right": "20px",
                                  },
                                  attrs: {
                                    disabled: _vm.isDownLoading,
                                    icon: "el-icon-download",
                                    type: "primary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onDownloadCategory(itemData.id)
                                    },
                                  },
                                },
                                [_vm._v("\n\t\t\t\t\t\t职业类别表\n\t\t\t\t\t")]
                              )
                            : _vm._e(),
                          itemData.productIdCenter &&
                          itemData.productIdCenter !== "0"
                            ? _c(
                                "el-link",
                                {
                                  staticStyle: { "font-size": "0.8em" },
                                  attrs: {
                                    disabled: _vm.isDownLoading,
                                    icon: "el-icon-document",
                                    type: "primary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onCreatePlan(itemData)
                                    },
                                  },
                                },
                                [_vm._v("\n\t\t\t\t\t\t投保计划书\n\t\t\t\t\t")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        {
                          staticStyle: { "margin-top": "8px", height: "80px" },
                        },
                        _vm._l(itemData.intros, function (item2, index2) {
                          return _c(
                            "div",
                            {
                              key: index2,
                              staticStyle: {
                                "font-size": "0.75em",
                                "padding-left": "0",
                              },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(item2) +
                                  "\n\t\t\t\t\t"
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _c(
                        "el-row",
                        { attrs: { justify: "center", type: "flex" } },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-bottom": "8px" },
                              attrs: {
                                loading:
                                  _vm.isInsureLoading &&
                                  _vm.insureType === itemData.insureType &&
                                  _vm.productId === itemData.id,
                                type: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleInsure(itemData)
                                },
                              },
                            },
                            [_vm._v("\n\t\t\t\t\t\t去投保\n\t\t\t\t\t")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { justify: "center", type: "flex" } },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "0.5625em",
                                color: "LightGray",
                              },
                            },
                            [_vm._v("承保：" + _vm._s(itemData.groupName))]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm.isShowInsureBegin
        ? _c("insure-begin-hint", { ref: "showHint" })
        : _vm._e(),
      _c("insure-notices", {
        ref: "refInsureNotices",
        on: { onToInsure: _vm.onGoInsure },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }